module.exports = __webpack_public_path__ + "static/media/rest-api.acce471c.jpg";